var _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHulu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 71.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#1CE783"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.07,22.2c0,0,0,27.75,0,28.71c0,2.54-2.05,4.6-4.6,4.6H87.5c-2.54,0-4.6-2.06-4.6-4.6 c0-0.96,0-28.71,0-28.71H65.74v30.14c0,12.32,7.88,18.81,19.53,18.81H99.7c11.65,0,19.53-6.49,19.53-18.81V22.2H102.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.85,22.2c0,0,0,27.75,0,28.71c0,2.54-2.05,4.6-4.6,4.6h-9.98c-2.54,0-4.6-2.06-4.6-4.6 c0-0.96,0-28.71,0-28.71h-17.16v30.14c0,12.32,7.88,18.81,19.53,18.81h14.42c11.65,0,19.53-6.49,19.53-18.81V22.2H198.85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.95,22.2c0,0-8.94,0-11,0c-3.86,0-5.8,1.04-5.8,1.04V0H0v71.15h17.15V42.44c0-2.54,2.06-4.6,4.6-4.6h9.98 c2.54,0,4.59,2.06,4.59,4.6v28.71l17.16,0V40.21C53.48,27.21,44.81,22.2,33.95,22.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    width: 17.16,
    height: 71.15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHulu);
export default __webpack_public_path__ + "static/media/hulu.06554f8f780ecb10f118c2170ff1cff4.svg";
export { ForwardRef as ReactComponent };